/// <amd-module name="SuiteCommerce.ShippingBar.PDPShippingBar.View"/>
define("SuiteCommerce.ShippingBar.PDPShippingBar.View", ["require", "exports", "Backbone", "suitecommerce_shippingbar_pdp.tpl", "SuiteCommerce.ShippingBar.Common.Utils"], function (require, exports, Backbone_1, suitecommerce_shippingbar_pdp_tpl, Utils_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ShippingBarPDPView = Backbone_1.View.extend({
        template: suitecommerce_shippingbar_pdp_tpl,
        title: Utils_1.Utils.translate('pdp-shipping-bar'),
        initialize: function (options) {
            var _this = this;
            this.amountWithItem;
            this.quantityWithItem;
            this.amountOfSelection = 0;
            this.model.on('cartAmount:changed pdpAmount:changed', function () {
                _this.cartAmount = _this.model.get('cartAmount');
                _this.render();
            });
            this.model.updateHeader();
            this.cartAmount = this.model.get('cartAmount');
            this.render();
        },
        setAmount: function () {
            if (this.model.attributes.pdp.getItemInfo() != null) {
                var hasChildren = false;
                var selectedQuantity = this.model.attributes.pdp.getItemInfo().quantity;
                if (isNaN(selectedQuantity) || selectedQuantity < 0) {
                    selectedQuantity = 0;
                }
                var isMatrixItem = this.model.attributes.pdp.getItemInfo().item.matrixchilditems_detail;
                if (isMatrixItem) {
                    hasChildren = this.model.attributes.pdp.getItemInfo().item.matrixchilditems_detail.length > 0;
                }
                if (hasChildren) {
                    // tslint:disable-next-line:max-line-length
                    this.amountOfSelection = (this.model.attributes.pdp.getSelectedMatrixChilds()[0].keyMapping_price * selectedQuantity);
                }
                else
                    this.amountOfSelection = (this.model.attributes.pdp.getItemInfo().item.keyMapping_price * selectedQuantity);
                this.amountWithItem = this.cartAmount + this.amountOfSelection;
            }
        },
        getContext: function () {
            this.setAmount();
            this.model.updateCurrencyConfiguration();
            var showDetailBanner = this.options.showDetailBanner;
            var actualAmount = this.model.get('cartAmount');
            var progressMessage = this.model.getMessage('pdpProgressMessage', this.amountWithItem);
            var itemQualifyMessage = this.model.get('itemQualifyMessage');
            var freeShippingAvailable = actualAmount >= this.model.attributes.shippingAmount;
            var getFreeShippingWithProduct = this.amountWithItem >= this.model.attributes.shippingAmount;
            if (showDetailBanner) {
                if (getFreeShippingWithProduct) {
                    showDetailBanner = !!itemQualifyMessage;
                }
                else
                    showDetailBanner = !!progressMessage;
            }
            return {
                freeShippingAvailable: freeShippingAvailable,
                getFreeShippingWithProduct: getFreeShippingWithProduct,
                progressMessage: progressMessage,
                showDetailBanner: showDetailBanner,
                itemQualifyMessage: itemQualifyMessage,
            };
        },
    });
});
